import _ from 'lodash';
import CovTerm from './CovTerm';

const createDescription = (model, onChange) => {
    let retDesc = model.name !== model.description ? model.description : '';
    if (onChange === _.noop) {
        if (model.terms && model.terms.length > 0) {
            model.terms.forEach((term) => {
                retDesc += `<p><strong>${term.name}: ${term.chosenTermValue}</strong></p>`;
            });
        }
    }
    return retDesc;
};

function Coverage(data) {
    if (data) {
        _.extend(this, data);
    }
}

Coverage.create = (model, loading, onChange) => {
    if (model === undefined) {
        return;
    }
    onChange = onChange || _.noop;

    const res = {
        name: model.name,
        amount: model.amount,
        monthlyAmount_ML: model.monthlyAmount_ML,
        required: model.required,
        publicID: model.publicID,
        description: createDescription(model, onChange),
        terms: model.terms.map((term) => {
            term.code_ML = model.code_ML;
            return CovTerm.create(term, loading, onChange)
        }),
        scheduledItems_ML: model.scheduledItems_ML,
        code_ML: model.code_ML,
        validationMessage_ML: model.validationMessage_ML,
        vehicleCovCosts_ML: model.vehicleCovCosts_ML ? model.vehicleCovCosts_ML.filter((cost) => !!cost) : null,
        isLineCovCost_Ext: model.isLineCovCost_Ext,
        lineCovCost_Ext: model.lineCovCost_Ext,
        lineLevelMonthlyCost_Ext: model.lineLevelMonthlyCost_Ext,
        isLineCoverage: model.isLineCoverage
    };

    Object.defineProperty(res, 'updating', {
        get: loading || _.constant(false)
    });

    if (res.required) {
        res.selected = true;
    } else {
        Object.defineProperty(res, 'selected', {
            get: () => {
                return model.selected;
            },
            set: (nv) => {
                model.selected = nv;
                model.updated = true;
                model.terms.forEach((term) => {
                    term.updated = true;
                });
                onChange(undefined, model.code_ML, model.hasTerms, true);
            }
        });
    }

    return Object.freeze(res);
};

export default Coverage;
